import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule } from '@angular/router';

import { appRoutes } from './app.routes';
import { AppRouteReuseStrategy } from './app-routing-strategy';
@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false, // <-- debugging purposes only
      paramsInheritanceStrategy: 'always', // <-- To get data aggregated from parent routes (for NGRX router)
      // https://angular.io/api/router/ExtraOptions#paramsInheritanceStrategy
      onSameUrlNavigation: 'reload'
    })
  ],

  providers: [{ provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy }],
  exports: [RouterModule]
})
export class AppRoutingModule {}
